import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UpgradeCTADialogComponent } from '@vendasta/uikit';
import { BehaviorSubject, Subscription, merge } from 'rxjs';
import { map, skipWhile, tap } from 'rxjs/operators';
import { VDC_APP_ID } from '../../../globals';
import { Account, AccountService } from '../account';
import { getCookie } from '../cookie';
import { Site, SiteService } from '../site';
import { GetProService } from './get-pro.service';

//Edition ID for pro version is an empty string
const proEditionId = '';

@Injectable()
export class UpgradeCTADialogService implements OnDestroy {
  dialogRef: MatDialogRef<UpgradeCTADialogComponent>;
  private accountId;
  private vbcEditionUpgradeUrl: string;
  private vbcEditionUpgradeUrlLoading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private vbcEditionUpgradeUrlLoading$ = this.vbcEditionUpgradeUrlLoading$$.asObservable();
  private subscriptions: Subscription[] = [];

  constructor(
    private account: AccountService,
    private dialog: MatDialog,
    private getProService: GetProService,
    private http: HttpClient,
    private siteService: SiteService,
  ) {}

  openUpgradeModel(): MatDialogRef<UpgradeCTADialogComponent> {
    this.dialogRef = this.dialog.open(UpgradeCTADialogComponent, {
      panelClass: 'app-full-bleed-dialog',
      autoFocus: false,
      data: this.getProService.PRO_CONFIG.get('upgrade'),
    });
    this.getBusinessCentreURL();
    return this.dialogRef;
  }

  getBusinessCentreURL(): void {
    this.subscriptions.push(
      merge(this.account.result(), this.siteService.get().pipe(tap((site: Site) => (this.accountId = site.accountId))))
        .pipe(map((res: Account | Site) => res.accountId))
        .subscribe((accountId: string) => {
          if (!this.accountId) {
            this.accountId = accountId;
          }

          let prod_navbar_URL = getCookie('product_navbar_data_url');
          if (prod_navbar_URL.includes('impersonatee')) {
            prod_navbar_URL = prod_navbar_URL.split('?impersonatee=', 2)[0];
          }
          const product_navbar_data_url = prod_navbar_URL + `?accountId=${this.accountId}&appId=${VDC_APP_ID}`;
          const navbarURL = product_navbar_data_url + `?accountId=${this.accountId}&appId=${VDC_APP_ID}`;
          this.http.get<any>(navbarURL).subscribe((response) => {
            const vbcBaseURL = response.data.urls.back_url;
            const origin = new URL(response.data.urls.notification_settings_url).origin;
            const items = encodeURIComponent(`[{"appId":"${VDC_APP_ID}","editionId":"${proEditionId}"}]`);
            // vbcBaseURL looks like: <vbcURL>/account/location/<agid>/products
            this.vbcEditionUpgradeUrl = vbcBaseURL
              .replace('products%2F', `edition-upgrades?items=${items}`)
              .replace('?nextUrl=', `?nextUrl=${origin}`);
            this.vbcEditionUpgradeUrlLoading$$.next(false);
          });
        }),
    );
  }

  businessCenterUpgrade(): void {
    this.vbcEditionUpgradeUrlLoading$
      .pipe(skipWhile((loading) => loading))
      .subscribe(() => window.location.assign(this.vbcEditionUpgradeUrl));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
